import { jsx } from "react/jsx-runtime";
function Checkmark() {
  return /* @__PURE__ */ jsx("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ jsx("path", {
      d: "M1.793 5.621a1 1 0 000 1.415l2.121 2.12a.995.995 0 00.773.292.996.996 0 00.641-.291l4.95-4.95a1 1 0 00-1.414-1.414L4.621 7.036 3.207 5.62a1 1 0 00-1.414 0z"
    })
  });
}
export {
  Checkmark
};
//# sourceMappingURL=Checkmark.js.map
